import Vue from 'vue';

Vue.component('promotion-report-table', () =>
    import(/* webpackChunkName: 'promotion-report-table' */ './promotion-report-table.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/promotion/index.js